import React from "react";
import _ from "lodash";
import Button from "Components/button/Button";
import QboxmailApi from "../../../qboxmailApi";
import Select from "Components/select/Select";
import DomainSelect from "Components/domainSelect/DomainSelect";
import DropdownIndicator from "Components/customArrowSelect/CustomArrowSelect";
import Loader from "Components/loader/Loader";
import ResourcesSelector from "Components/resourcesSelector/ResourcesSelector";
import TranslatedString from "Components/TranslatedString";
import { t } from "i18next";
// import s from "../archive.scss";
import PropTypes from "prop-types";
import CustomerSelect from "Components/customerSelect/CustomerSelect";
import HelpTooltip from "Components/helpTooltip/HelpTooltip";
import WarningBanner from "Components/warningBanner/WarningBanner";

import cx from "classnames";

const ContextTypes = {
  getLoggedUser: PropTypes.func,
  isLoggedUserAdmin: PropTypes.func
};

class EmailsForm extends React.Component {
  constructor(props) {
    super(props);
    this.goToNextStep = this.goToNextStep.bind(this);
    this.refreshDomainSelector = this.refreshDomainSelector.bind(this);
    this.selectEmail = this.selectEmail.bind(this);
    const domainCode = props.match.params.domainCode;

    this.state = {
      selectedDomain: domainCode || undefined,
      isAddingDomain: !domainCode,
      emails: [],
      loadingEmails: false,
      customerDomains: undefined
    };
  }

  componentDidMount() {
    if (!this.context.isLoggedUserAdmin()) {
      // get ALL customer domains
      let client = new QboxmailApi({ useCookie: true });
      client
        .getDomains({
          per: 999999999
        })
        .then(data => this.filterSaveDomains(data.resources));
    }

    if (this.props.match.params.domainCode) {
      this.selectDomainAndLoadEmails(this.props.match.params.domainCode);
    }

    // check limits if they are ready
    if (!this.props.loadingLimits) {
      this.setState({ limitExceeded: this.props.available <= 0 && this.props.available !== -1 });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // check limits when they are ready
    if (this.props.loadingLimits && !nextProps.loadingLimits) {
      this.setState({ limitExceeded: nextProps.available <= 0 && nextProps.available !== -1 });
    }
  }

  filterSaveDomains(domains) {
    this.setState({
      customerDomains: domains.map(d => {
        let isDisabled = false;
        if (d.archive || d.status == "ownership_check" || d.status == "disabled") {
          isDisabled = true;
        }

        return { value: d.code, label: d.name, isDisabled };
      })
    });
  }

  goToNextStep(e) {
    const {
      setFormLoading,
      unsetFormLoading,
      setFormErrors,
      setDataForm,
      goToStep,
      formData
    } = this.props;
    const { isAddingDomain } = this.state;
    e.preventDefault();
    setFormLoading();
    this.validate(formData).then(errors => {
      if (Object.keys(errors).length > 0) {
        setFormErrors(errors);
      } else {
        setDataForm(this.state.formData);
        if (isAddingDomain) {
          goToStep(2);
        } else {
          goToStep(4);
        }
      }
      unsetFormLoading();
    });
  }

  validate({ email_codes, domain_code }) {
    return new Promise(function(resolve) {
      let errors = {};
      let emailCodes = _.compact(
        _.map(email_codes, (v, k) => {
          if (email_codes[k] === true) return k;
        })
      );

      if (emailCodes.length <= 0) {
        errors.onForm = t("errorMsg.select.account");
        return resolve(errors);
      }

      const api = new QboxmailApi({ useCookie: true });
      api
        .validateArchiveLimits(domain_code, emailCodes)
        .then(response => {
          if (response.valid) {
            resolve(errors);
          } else {
            errors.onForm = response.message;
            resolve(errors);
          }
        })
        .catch(() => {
          errors.name = "is not valid";
          resolve(errors);
        });
    });
  }

  selectDomainAndLoadEmails(domainCode) {
    this.setState({ selectedDomain: domainCode });
    this.props.setFormFieldValue({ domain_code: domainCode, email_codes: {} });
    if (!domainCode) {
      this.setState({ emails: [] });
      return false;
    }
    this.setState({ loadingEmails: true });
    let client = new QboxmailApi({ useCookie: true });
    return client
      .getDomainsEmailAccounts(domainCode, {
        per: 10000,
        postmaster: true
      })
      .then(data => {
        let totalEmails = data.resources.map(em => ({
          value: em.code,
          label: em.email_address,
          disabled: em.archive
        }));

        if (!this.context.isLoggedUserAdmin()) {
          _.remove(totalEmails, em => em.label.match(/postmaster@/));
        }

        this.setState({ emails: totalEmails, loadingEmails: false });
        this.props.setData({ totalEmails });
      })
      .catch(e => {
        this.setState({ emails: [], loadingEmails: false });
        if (e instanceof Error) throw e;
      });
  }

  refreshDomainSelector(val) {
    this.props.setFormFieldValue({ customer_code: val ? val.value : null }, () => {
      if (!val) {
        // clean selections
        this.setState({ selectedDomain: undefined, emails: [], limitExceeded: false });
        return;
      }

      // get ALL customer domains
      let client = new QboxmailApi({ useCookie: true });
      client
        .getDomains({
          per: 999999999,
          customer_code: val.value
        })
        .then(data => this.filterSaveDomains(data.resources));
    });

    // trigger limit checking
    if (val) {
      this.props.getUserLimits(val.value);
    }
  }

  selectEmail(val) {
    if (val.email_codes && this.props.available !== -1) {
      let selected = Object.keys(val.email_codes).filter(code => val.email_codes[code]).length;
      this.setState({ limitExceeded: selected > this.props.available });
    }

    this.props.setFormFieldValue(val);
  }

  render() {
    const {
      formErrors,
      formData,
      setFormFieldValue,
      isFormLoading,
      isLoggedUserAdmin
    } = this.props;

    const { loadingEmails, emails, selectedDomain, isAddingDomain } = this.state;
    let customerArchiveLimit, avalaibleArchiveEmails;
    const loggedUser = this.context.getLoggedUser();
    customerArchiveLimit = parseInt(loggedUser.max_email_accounts_archive);
    avalaibleArchiveEmails = customerArchiveLimit - parseInt(loggedUser.email_accounts_archive);

    const domainHasNoEmails = !loadingEmails && emails.length === 0 && selectedDomain;
    const domainHasEmails = !loadingEmails && emails.length > 0 && selectedDomain;

    return (
      <div className="formsPage">
        {this.props.stepper}
        <div className={cx("sectionTitle", "titleFP")}>{t("archive.add.title.step1")}</div>

        <div className="wrapScrollFP">
          <div className="infoFP">
            <div className="sectionDesc">
              {<TranslatedString>archive.add.desc.step1</TranslatedString>}
            </div>
            <Button
              className="btnDocsFP"
              docsKey={isAddingDomain ? "archive_domain_add" : "archive_emailAccount_add"}
              color="docs"
              sizeSmall
            >
              button.docs
            </Button>
          </div>

          <form className="wrapFormsFP" method="post" onSubmit={this.goToNextStep}>
            <div className="formsFP">
              {isLoggedUserAdmin && isAddingDomain && (
                <CustomerSelect
                  className={cx("inputFull2", "addMarginFP")}
                  label={t("input.label.customer")}
                  onChange={this.refreshDomainSelector}
                  required
                />
              )}
              {((isLoggedUserAdmin && formData.customer_code) || !isLoggedUserAdmin) &&
                isAddingDomain && (
                  <Select
                    className="inputFull2"
                    label={t("input.label.domain")}
                    components={{ DropdownIndicator }}
                    name="domain"
                    options={this.state.customerDomains}
                    onChange={val => this.selectDomainAndLoadEmails(val.domain)}
                    helpTooltip={
                      <HelpTooltip
                        children={[
                          {
                            description: t("helpT.addArchive.step1"),
                            key: 0
                          }
                        ]}
                      />
                    }
                  />
                )}

              {this.state.loadingEmails && (
                <div className="inputFull2">
                  <Loader iconSize="2rem" msg={t("infoMsg.loading.accounts")} />
                </div>
              )}

              {domainHasNoEmails && (
                <div className={cx("inputFull2")}>
                  <WarningBanner msg={t("infoMsg.noDomsSelected")} />
                </div>
              )}
              {domainHasEmails && (
                <ResourcesSelector
                  className={cx("inputFull2", "addMarginFP")}
                  resources={this.state.emails}
                  checkeds={formData.email_codes}
                  onChange={this.selectEmail}
                  disabledMsg={t("infoMsg.archiveAlready")}
                  name="email_codes"
                />
              )}
            </div>

            {formErrors.onForm && (
              <div className="warningMsgFP">
                <WarningBanner msg={formErrors.onForm} />
              </div>
            )}

            {this.state.limitExceeded && (
              <div className="warningMsgFP">
                <WarningBanner color="red" msg={"Limite di email con archivio superato"} />
              </div>
            )}

            <div className="footerFP">
              <Button color="text" type="button" onClick={() => this.props.resetAndGoBack()}>
                button.cancel
              </Button>
              <Button
                type="submit"
                loading={isFormLoading}
                disabled={this.state.emails.length === 0 || this.state.limitExceeded}
              >
                button.continue
              </Button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

EmailsForm.contextTypes = ContextTypes;
export default EmailsForm;
